
import { Component, Vue } from 'vue-property-decorator';

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import { form4StatusInfoType } from '@/types/Information/Form4';

@Component({
    components:{
        Form4ProcessHeader
    }
})
export default class CancelSubmitForm4 extends Vue {

    stepsCompleted = {} as form4StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
